__turbopack_context__.v({
  "cColorInputField": "style-module-scss-module__0cwNAa__cColorInputField",
  "cCorporateDesign__fontsWrap": "style-module-scss-module__0cwNAa__cCorporateDesign__fontsWrap",
});
